import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('promo-banner-dismissed', 'true');
  };
  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem('promo-banner-dismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);
  if (!isVisible) return null;
  return <div className="relative bg-gradient-to-r from-red-600 via-red-600 to-red-700 text-white shadow-lg z-50" data-id="element-1262" data-mp="3135fd2q7exd6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3" data-id="element-1263" data-mp="3f36gmjads6t6">
        <div className="flex items-center justify-between gap-4" data-id="element-1264" data-mp="3a28yg6pdfcro">
          {/* Left: Icon + Message */}
          <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-1265" data-mp="uacqkoxsop0b">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center" data-id="element-1266" data-mp="pcb5jygt6fm7">
              <Sparkles size={16} className="text-white" data-id="element-1267" data-mp="dk6r46b4rjl5" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1268" data-mp="dm02fywourzh">
              <p className="text-sm sm:text-base font-semibold leading-tight" data-id="element-1269" data-mp="hk7hmpbi7l8k">
                <span className="hidden sm:inline" data-id="element-1270" data-mp="mjtw1232j7iy">
                  One full forensic scan for{' '}
                </span>
                <span className="text-yellow-300" data-id="element-1271" data-mp="ri3qfagyy43i">$2.99</span>
                <span className="hidden sm:inline" data-id="element-1272" data-mp="3q1c1x3za64gq">
                  {' '}
                  — or go unlimited from $9.99 a week.
                </span>
                <span className="sm:hidden" data-id="element-1273" data-mp="3v0euvq1zkk8c"> per full scan</span>
              </p>
            </div>
          </div>

          {/* Right: CTA + Close */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-id="element-1274" data-mp="8l2j3izxzrwe">
            <a href="/payment" className="bg-white text-red-600 px-4 sm:px-6 py-2 rounded-lg font-bold text-sm hover:bg-red-50 transition-all shadow-md hover:shadow-lg whitespace-nowrap" data-id="element-1275" data-mp="37akj7btel1po">
              Upgrade
            </a>
            <button onClick={handleDismiss} className="p-1.5 hover:bg-white/20 rounded-lg transition-colors flex-shrink-0" aria-label="Dismiss banner" data-id="element-1276" data-mp="347en0tvl40yx">
              <X size={18} data-id="element-1277" data-mp="3dxzjobrp6vf7" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}
export default PromoBanner;